import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import AdditionalTestsForm from '../../../../itrust_common/components/authorised/examFormPartial/AdditionalTestsForm';
import { useEffect } from 'react';

function AdditionalTestForm(props) {
  const { handleSubmit, template } = props;

  useEffect(() => {
    return () => {
      if (props.dirty) {
        handleSubmit();
      }
    }
  }, [props.dirty])

  return (
    <form onSubmit={handleSubmit}>
      <AdditionalTestsForm pprops={props} template={template} isTemplate={false} />
    </form>
  )
}

AdditionalTestForm = reduxForm({
  form: 'examAdditionalTestForm',
  enableReinitialize: true,
})(AdditionalTestForm)

const mapStateToProps = state => {
  const { exam: { exam } } = state
  return {
    initialValues: {
      id: exam.id,
      additional_tests_attributes: exam.additional_tests_attributes
    }
  }
}

export default connect(mapStateToProps)(AdditionalTestForm);